var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"d-activity-timestamp text-grey-dark"},[_vm._v(_vm._s(_vm.activity.time_ago)+" ago")])}
var staticRenderFns = []

export { render, staticRenderFns }